import { render } from "./LayoutMenu.vue?vue&type=template&id=6025c694"
import script from "./LayoutMenu.vue?vue&type=script&lang=js"
export * from "./LayoutMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__